import { render, staticRenderFns } from "./GAAdetail.vue?vue&type=template&id=d8567c2c&scoped=true"
import script from "./GAAdetail.vue?vue&type=script&lang=js"
export * from "./GAAdetail.vue?vue&type=script&lang=js"
import style0 from "./GAAdetail.vue?vue&type=style&index=0&id=d8567c2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8567c2c",
  null
  
)

export default component.exports